import { useToast } from '@quadminds/mindkit';
import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCopyToClipboard } from 'usehooks-ts';
import useFeedbackDialog from './useFeedbackDialog';
import useGetQuestions from './useGetQuestions';

const useQuestionPage = () => {
    const {
        userInfo,
        isDialogOpen,
        isImpersonated,
        feedback,
        setFeedback,
        isSubmitting,
        handleSubmit,
        handleClose,
        setIsDialogOpen,
    } = useFeedbackDialog();
    const navigate = useNavigate();

    const { getQuersionsQuery } = useGetQuestions();
    const [selectedCategory, setSelectedCategory] = useState<string>('all');

    const { toast } = useToast();
    const [, copyToClipboard] = useCopyToClipboard();

    const handleCopyQuestion = async (questionText: string) => {
        try {
            await copyToClipboard(questionText);
            toast({
                title: 'Pregunta copiada',
                description: 'La pregunta se copió al portapapeles',
                variant: 'default',
                duration: 3000,
            });
        } catch (error) {
            toast({
                title: 'Error al copiar',
                description: 'No se pudo copiar la pregunta al portapapeles',
                variant: 'destructive',
                duration: 3000,
            });
        }
    };

    const filteredCategories = useMemo(() => {
        const categories =
            selectedCategory === 'all'
                ? getQuersionsQuery.data
                : getQuersionsQuery.data?.filter((cat) => cat.id === selectedCategory);

        return categories
            ?.map((category) => ({
                ...category,
                questions: [...category.questions].sort((a, b) => a.order - b.order),
            }))
            .sort((a, b) => a.order - b.order);
    }, [selectedCategory, getQuersionsQuery.data]);

    return {
        selectedCategory,
        setSelectedCategory,
        filteredCategories,
        isDialogOpen,
        setIsDialogOpen,
        userInfo,
        isImpersonated,
        feedback,
        setFeedback,
        isSubmitting,
        handleSubmit,
        handleClose,
        navigate,
        getQuersionsQuery,
        handleCopyQuestion,
    };
};

export default useQuestionPage;
